var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSongClaimUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.66602V7.33268H8.83333V11.0827C8.83325 11.5126 8.70016 11.9319 8.45234 12.2832C8.20451 12.6345 7.85408 12.9005 7.4491 13.0448C7.04412 13.1891 6.60443 13.2045 6.19032 13.089C5.77622 12.9735 5.40799 12.7327 5.13612 12.3997C4.86426 12.0667 4.70208 11.6577 4.67183 11.2289C4.64158 10.8 4.74474 10.3723 4.96716 10.0044C5.18957 9.63651 5.52036 9.34643 5.91415 9.17395C6.30794 9.00147 6.74545 8.95503 7.16667 9.04102V5.66602H10.5V2.33268H2.16667V15.666H13.8333V5.66602H11.3333ZM0.5 1.49268C0.5 1.03602 0.8725 0.666016 1.3325 0.666016H11.3333L15.5 4.83268V16.4935C15.5008 16.603 15.48 16.7115 15.4388 16.8129C15.3976 16.9143 15.3369 17.0066 15.2601 17.0845C15.1832 17.1624 15.0918 17.2244 14.991 17.267C14.8902 17.3096 14.7819 17.3319 14.6725 17.3327H1.3275C1.10865 17.3312 0.899181 17.2436 0.744348 17.0889C0.589515 16.9342 0.501746 16.7249 0.5 16.506V1.49268Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSongClaimUnselected);
export default __webpack_public_path__ + "static/media/song_claim_unselected.8d36be46deb1e70e05f34e9dfb537be6.svg";
export { ForwardRef as ReactComponent };